<template>
  <v-row class="recipients-unrestricted-gift-link">
    <v-col cols="12" class="recipients-unrestricted-gift-link__label">
      Enter the maximum number of recipients that can redeem
    </v-col>
    <v-col cols="12">
      <common-input
        v-model.number="recipientsNumber"
        type="number"
        min="1"
        ref="recipientsNumber"
        suffix="Recipients"
        style="max-width: 140px"
      />
    </v-col>
    <!-- <v-col cols="12" class="recipients-unrestricted-gift-link__sub-text">
      Enter the maximum number of recipients that can redeem this eGift.
      With this method, we will not validate recipients by name or email
    </v-col> -->
    <v-col cols="12" class="pb-4">
      <the-recipients-area-email-restrictions
        :emailRestrictions.sync="restrictions"
      />
    </v-col>
    <v-col cols="12">
      <common-button
        height="44"
        style="width: 280px"
        :disabled="numberOfRecipients <= 0"
        @click="handleContinue()"
      >
        Continue to review eGift
      </common-button>
    </v-col>
  </v-row>
</template>

<script>
import TheRecipientsAreaEmailRestrictions from './TheRecipientsAreaEmailRestrictions.vue'
import { EMAIL_RESTRICTION_MODE } from './emailRestrictionMode'

export default {
  name: 'TheRecipientsAreaUnrestrictedGiftLink',
  components: {
    TheRecipientsAreaEmailRestrictions,
  },
  props: {
    numberOfRecipients: {
      type: Number,
      required: false,
      default: null
    },
    emailRestrictions: {
      type: Object,
      required: false,
      default: () => ({
        enabled: false,
        mode: EMAIL_RESTRICTION_MODE.BLOCK_FREE_DOMAINS,
        blockedDomains: [],
        includeOtherFreeProviders: false,
        allowedDomains: [],
      })
    }
  },
  computed: {
    recipientsNumber: {
      get () { return this.numberOfRecipients },
      set (val) { this.$emit('update:numberOfRecipients', val || null) },
    },
    restrictions: {
      get () { return this.emailRestrictions },
      set (val) { this.$emit('update:emailRestrictions', val) },
    },
    isEmailRestrictionValid () {
      const { enabled, mode, blockedDomains, includeOtherFreeProviders, allowedDomains } = this.emailRestrictions

      if (!enabled) return true

      if (mode === EMAIL_RESTRICTION_MODE.BLOCK_FREE_DOMAINS) {
        return blockedDomains.length > 0 || includeOtherFreeProviders
      }

      return allowedDomains.length > 0
    }
  },
  mounted () {
    this.$el.querySelector('input')?.focus()
  },
  methods: {
    handleContinue () {
      if (!this.isEmailRestrictionValid) {
        this.$cgToast.error('Add at least one domain or provider to apply the email restriction, or uncheck email restrictions to continue.')
        return
      }

      this.$emit('showPreview', [])
    }
  }
}
</script>

<style lang="scss">
.recipients-unrestricted-gift-link {
  .v-input .v-input__slot .v-text-field__suffix {
    font-family: 'Lato-Italic', sans-serif;
    font-size: 15px;
    color: #a1a1a1;
  }

  &__label {
    font-family: 'Lato-Bold', 'Lato', sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: normal;
    color: #000;
  }

  &__sub-text {
    font-family: 'Lato-Italic', sans-serif;
    font-size: 15px;
    line-height: 18px;
    color: #95979D;
  }
}
</style>
